import { render } from "./ArticleView.vue?vue&type=template&id=fc82ef94&scoped=true"
import script from "./ArticleView.vue?vue&type=script&lang=js"
export * from "./ArticleView.vue?vue&type=script&lang=js"

import "./ArticleView.vue?vue&type=style&index=0&id=fc82ef94&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fc82ef94"

export default script